import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { useLayout } from '@/theme/useLayout';
import { LanguageMenu } from './LanguageMenu';

/**
 * The header dropdown shown before sign-in: login, fullscreen and the language
 * picker. No registration entry — accounts are created by an administrator.
 */
export function GuestMenu() {
  const { t } = useTranslation();
  const { isFullscreen, toggleFullscreen } = useLayout();

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="button"
        type="button"
        className="btn-system bg-transparent no-arrow d-flex flex-shrink-0 align-items-center justify-content-center"
        aria-label={t('OpenGuestMenu', 'Open guest menu')}
      >
        <div className="profile-image profile-image-md rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center">
          <svg className="sa-icon" width="20" height="20">
            <use href="/myui/icons/sprite.svg#user" />
          </svg>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu renderOnMount className="dropdown-menu-animated">
        <div className="dropdown-header">
          <span className="text-muted">{t('GuestUser', 'Guest user')}</span>
        </div>

        <div className="dropdown-divider m-0" />

        <Dropdown.Item as={Link} to="/auth-login" className="d-flex align-items-center">
          <i className="bi bi-box-arrow-in-right me-2" />
          <span>{t('Login', 'Login')}</span>
        </Dropdown.Item>

        <div className="dropdown-divider m-0" />

        <Dropdown.Item
          as="button"
          type="button"
          className="d-flex justify-content-between align-items-center"
          aria-pressed={isFullscreen}
          onClick={toggleFullscreen}
        >
          <span className="d-flex align-items-center">
            <i className="bi bi-arrows-fullscreen me-2" />
            <span>{t('Fullscreen', 'Fullscreen')}</span>
          </span>
          <b className="text-muted fs-nano px-2 rounded font-monospace align-self-center border">F11</b>
        </Dropdown.Item>

        <LanguageMenu />
      </Dropdown.Menu>
    </Dropdown>
  );
}
